import script from "./AnswerRateDistribution.vue?vue&type=script&setup=true&lang=js"
export * from "./AnswerRateDistribution.vue?vue&type=script&setup=true&lang=js"

import "./AnswerRateDistribution.vue?vue&type=style&index=0&id=43b1dab6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43b1dab6"]])

export default __exports__